import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import { Copy as ContentCopyIcon, Check as CheckIcon } from 'lucide-mui';
import DownloadFile from '../../../selectedVideo/tabs/Download';

interface AIResultAccordionProps {
  onCopyContent: (text: string) => void;
  copySuccess: boolean;
  downloadText: string;
  fileName: string;
}

// Helper function to clean citation references
const cleanText = (text: string): string => {
  return text.replace(/\[→\]\([^)]+\)/g, '');
};

const AIResultAccordion: React.FC<AIResultAccordionProps> = ({
  onCopyContent,
  copySuccess,
  downloadText,
  fileName,
}) => {
  const cleanedText = cleanText(downloadText);

  return (
    <>
      <Tooltip
        title={copySuccess ? 'Copied!' : 'Copy content'}
        placement="top"
        arrow
      >
        <IconButton
          onClick={() => onCopyContent(cleanedText)}
          size="small"
          sx={{
            color: 'text.secondary',
            borderRadius: '4px',
            width: '30px',
            height: '30px',
            padding: '6px',
            '&:hover': {
              color: 'text.primary',
            },
          }}
        >
          {copySuccess ? (
            <CheckIcon fontSize="small" />
          ) : (
            <ContentCopyIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          '& .MuiIconButton-root': {
            color: 'text.secondary',
            borderRadius: '4px',
            width: '30px',
            height: '30px',
            padding: '6px',
            '&:hover': {
              color: 'text.primary',
            },
          },
        }}
      >
        <DownloadFile text={cleanedText} fileName={fileName} variant="icon" />
      </Box>
    </>
  );
};

export default AIResultAccordion;
